<template>
  <div class="add-or-edit-staff-dialog">
    <common-dialog
      :show.sync="visible"
      :title="type === 'add' ? '新增成员' : '编辑成员'"
      class="staff-dialog"
    >
      <div class="dialog-body">
        <el-form :model="dataModel" ref="dataForm" :rules="rules" label-width="88px">
          <el-form-item label="账号" prop="mobile_phone" v-if="type === 'add'">
            <el-input type="text" v-model.trim="dataModel.mobile_phone" placeholder="请输入手机号码" :maxlength="11"></el-input>
          </el-form-item>

          <!-- 不能prop去除，否则resetFields时候报错 -->
          <el-form-item label="账号" prop="mobile_phone" v-else>
            <div class="form-item-text">{{dataModel.mobile_phone}}</div>
          </el-form-item>
          

          <el-form-item label="角色" prop="role_id">
            <div class="role-form-item">
              <el-select class="role-select" v-model="dataModel.role_id" placeholder="请选择">
                <el-option label="财务" :value="2"></el-option>
                <el-option label="操作员" :value="1"></el-option>
              </el-select>
              <span class="role-tips" @click="roleDesc.show = true">权限说明</span>
            </div>
          </el-form-item>

          <el-form-item label="密码" prop="passwd" v-if="type === 'add' || showPasswordInput">
            <el-input type="text" v-model.trim="dataModel.passwd" :maxlength="20" placeholder="输入6-20位字母和数字"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="passwd" class="is-required" :rules="{required: false}" v-else>
            <div class="update-password-box">
              <div class="text">******</div>
              <button class="btn" @click="showPasswordInput = true">修改密码</button>
            </div>
          </el-form-item>

          <el-form-item label="联系人" prop="name">
            <el-input type="text" v-model.trim="dataModel.name" :maxlength="10" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>

          <el-form-item label="手机号" prop="phone_number">
            <el-input type="text" v-model.trim="dataModel.phone_number" placeholder="请输入联系人手机号码" :maxlength="11"></el-input>
          </el-form-item>

          <el-form-item label="邮箱地址" prop="email">
            <el-input type="text" v-model.trim="dataModel.email" :maxlength="50" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="staff-dialog-footer" slot="footer">
        <button @click="visible = false" class="s-btn btn-info btn-lg">取消</button>
        <button @click="formSubmit" class="s-btn btn-blue btn-lg">保存</button>
      </div>

    </common-dialog>

    <role-desc-dialog
      :show.sync="roleDesc.show"
    ></role-desc-dialog>

  </div>
</template>

<script>
import CommonDialog from '../../../../components/common/modals/common-dialog/common-dialog.vue';
import validates from '../../../../libs/validates';
import utils from '../../../../libs/utils';
import Http from '../../../../libs/http';
import RoleDescDialog from './role-desc-dialog.vue';

export default {
  components: {
    CommonDialog,
    RoleDescDialog,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    type: {
      type: String,
      default: 'add',
    },
    staffInfo: Object,
  },
  data() {
    return {
      visible: false,
      showPasswordInput: false,
      dataModel: {
        mobile_phone: '',
        passwd: '',
        name: '',
        phone_number: '',
        email: '',
        role_id: '',
      },
      rules: {
        mobile_phone: [
          validates.required('账号'),
          validates.mobile('账号'),
        ],
        passwd: [
          validates.required('密码'),
          validates.range(20, 6, '密码'),
        ],
        role_id: [
          { required: true, trigger: 'blur', message: '请选择角色', type: 'number' },
        ],
        name: [
          validates.required('联系人'),
          validates.linkName('联系人'),
          validates.range(10, 2, '联系人'),
        ],
        phone_number: [
          validates.required('联系人手机号'),
          validates.mobile('联系人手机号'),
        ],
        email: [
          validates.email('邮箱地址'),
        ],
      },
      // 显示操作说明弹窗
      roleDesc: {
        show: false,
      },
    };
  },
  computed: {
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        // 子组件没加载完，执行会报错
        this.init();
      } else {
        this.$nextTick(() => {
          this.$refs.dataForm && this.$refs.dataForm.resetFields();
        });
      }
    },
  },
  methods: {
    init() {
      this.showPasswordInput = false;
      this.dataModel.mobile_phone = this.staffInfo ? this.staffInfo.mobile_phone : '';
      this.dataModel.passwd = this.staffInfo ? this.staffInfo.passwd : '';
      this.dataModel.name = this.staffInfo ? this.staffInfo.name : '';
      this.dataModel.phone_number = this.staffInfo ? this.staffInfo.phone_number : '';
      this.dataModel.email = this.staffInfo ? this.staffInfo.email : '';
      this.dataModel.role_id = this.staffInfo ? this.staffInfo.role_id : '';
    },
    formSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const postData = utils.extend({}, this.dataModel);
          if (this.type === 'add') {
            postData.passwd = utils.md5(postData.passwd);
          } else {
            postData.new_passwd = this.showPasswordInput ? utils.md5(postData.passwd) : undefined;
            delete postData.passwd;
            postData.peer_account_id = this.staffInfo.peer_account_id;
          }
          Http.post(this.type === 'add' ? '/peer_account_add' : '/peer_account_update', postData).then(() => {
            utils.msg.success(this.type === 'add' ? '添加成功' : '编辑成功');
            this.$emit('success');
            this.visible = false;
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.staff-dialog{
  /deep/ .el-dialog{
    width: 600px;
  }
}
.dialog-body{
  padding: 24px 24px 0 24px;
  /deep/ .el-form-item{
    margin-bottom: 24px;
    .el-form-item__label{
      padding-right: 10px;
      color: #2F333D;
      font-size: 16px;
      font-weight: 600;

      &::after{
        content: '*';
        color: #fff;
        margin-left: 4px;
        font-weight: 400;
      }
    }
    &.is-required{
      .el-form-item__label{
        &::before{
          display: none;
        }
        &::after{
          color: #FF6464;
        }
      }
    }
  }
  /deep/ .el-input__inner{
    height: 40px;
    border-radius: 2px;
    color: #2F333D;
    font-size: 14px;
  }

  .update-password-box{
    width: 100%;
    height: 40px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #DEE2E6;
    position: relative;
    display: flex;
    align-items: center;
    line-height: 1;
    padding: 0 10px;
    .text{
      color: #2F333D;
      font-size: 14px;
      padding-top: 3px;
    }
    .btn{
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 72px;
      height: 24px;
      background: #FFFFFF;
      border-radius: 1px;
      border: 1px solid #599FFF;
      cursor: pointer;
      outline: none;
      font-size: 12px;
      color: #599FFF;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .role-form-item {
    display: flex;
    align-items: center;
    /deep/ .role-select {
      .el-input__inner {
        width: 160px;
      }
    }
    .role-tips {
      margin-left: 12px;
      font-size: 12px;
      line-height: 12px;
      color: #91999F;
      display: flex;
      align-items: center;
      &::after {
        content: "";
        display: inline-block;
        cursor: pointer;
        flex-shrink: 0;
        margin-left: 4px;
        background: url(../../../../assets/imgs/new-user/icon-tips.png) no-repeat center / 100% 100%;
        width: 16px;
        height: 16px;
      }
    }
  }
  
}

</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/add-or-edit-staff-dialog.vue